<template>
  <v-text-field
    type="number"
    :label="this.data.text"
    :rules="this.data.rules"
    v-model="inputValue"
    v-on:change="onBlur"
    v-on:keyup="onKeyUp"
    v-on:keydown="onKeyDown"
    ref="numberTextField"
  />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Number',
  data() {
    return {
      inputValue: this.data.value
    };
  },
  props: {
    data: Object
  },
  methods: {
    setFocus() {
      this.$refs['numberTextField'].focus();
    },
    change(mode) {
      if (mode === 'keyup' && this.data.onkeyup) {
        this.emitToParent();
      } else if (mode === 'blur' && this.data.onblur) {
        this.emitToParent();
      }
    },
    onKeyUp() {
      this.change('keyup');
    },
    onKeyDown(e) {
      if (e.key.toLowerCase() === 'enter' && this.data.router !== '' && this.data.router !== undefined) {
        if (this.data.name === 'kilometers' && this.$store.state.user.user.registrationplate !== '') {
          this.$router.push({ name: this.data.router });
        }
      }
    },
    onBlur() {
      this.change('blur');
    },
    emitToParent() {
      this.$emit('childToParent', this.inputValue);
    }
  }
});
</script>

<style scoped lang="scss">
input {
  background: silver;
}
</style>
